import request from '@/utils/request'

export function getInitTime() {
    return request({
        url: '/store/api.init/index',
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/getTime.js